(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function addItems(ids, button) {
    var list = (ids || [])
      .map(function (id) {
        return String(id || '').trim();
      })
      .filter(Boolean);
    if (!list.length) return Promise.resolve();
    if (!window.ScenarioCart || typeof window.ScenarioCart.addItems !== 'function') {
      return Promise.reject(new Error('cart unavailable'));
    }
    return window.ScenarioCart.addItems({
      items: list.map(function (id) {
        return { id: id, quantity: 1 };
      }),
      button: button,
      source: 'om-creator'
    });
  }

  function relocateAnchorNav(root) {
    if (!root) return;
    var slot = root.querySelector('[data-om-anchor-slot]');
    var nav = document.querySelector('.event-anchor-nav');
    if (!slot || !nav) return;

    var wrap = nav.closest('[id^="shopify-section-"]');
    var omWrap = root.closest('[id^="shopify-section-"]');

    if (nav.parentNode !== slot) {
      slot.appendChild(nav);
    }
    nav.classList.add('is-placed');

    if (wrap && wrap !== omWrap) {
      wrap.setAttribute('hidden', '');
      wrap.style.display = 'none';
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.omReady === 'true') return;
    root.dataset.omReady = 'true';

    relocateAnchorNav(root);
    initTabs(root);
    initBundles(root);
    initAccessories(root);
    initCompare(root);
    initCalendar(root);
    initSurvey(root);
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-om-tab]');
    var scenes = root.querySelectorAll('[data-om-scene]');
    if (!tabs.length) return;

    var scroller = root.querySelector('[data-om-tabs]');
    var prev = root.querySelector('[data-om-tabs-prev]');
    var next = root.querySelector('[data-om-tabs-next]');

    function isMobileTabs() {
      return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches;
    }

    function tabsMaxScroll() {
      if (!scroller) return 0;
      return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    }

    function setTabArrowVisible(arrow, visible) {
      if (!arrow) return;
      arrow.classList.toggle('is-visible', !!visible);
      arrow.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function updateTabArrows() {
      if (!scroller || !prev || !next) return;
      if (!isMobileTabs()) {
        setTabArrowVisible(prev, false);
        setTabArrowVisible(next, false);
        return;
      }
      var maxScroll = tabsMaxScroll();
      if (maxScroll <= 2) {
        setTabArrowVisible(prev, false);
        setTabArrowVisible(next, false);
        return;
      }
      var sl = scroller.scrollLeft;
      setTabArrowVisible(prev, sl > 4);
      setTabArrowVisible(next, sl < maxScroll - 4);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-om-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        scenes.forEach(function (scene) {
          scene.hidden = scene.getAttribute('data-om-scene') !== key;
        });
        if (scroller && isMobileTabs() && typeof tab.scrollIntoView === 'function') {
          tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        }
        updateTabArrows();
      });
    });

    if (scroller && prev && next) {
      scroller.addEventListener('scroll', updateTabArrows, { passive: true });
      prev.addEventListener('click', function () {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        scroller.scrollTo({ left: tabsMaxScroll(), behavior: 'smooth' });
      });
      window.addEventListener('resize', updateTabArrows);
      updateTabArrows();
    }
  }

  function resolvePriceLabel(root, scene, pill) {
    var custom = (pill.getAttribute('data-price-label') || '').trim();
    if (custom) return custom;
    var tab = (scene.getAttribute('data-tab-label') || '').trim().toLowerCase();
    var pillLabel = (pill.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (tab === 'action shots' && pillLabel === 'standard combo') {
      return 'Combo Price';
    }
    // Travel / Family / Action 各自第 3 个套装（All-in Combo）→ Combo Price
    if (String(pill.getAttribute('data-bundle-index') || '') === '3') {
      return 'Combo Price';
    }
    return (root.getAttribute('data-bundle-price-label') || 'Bundle Price').trim() || 'Bundle Price';
  }

  function applyBundle(root, scene, pill) {
    if (!scene || !pill) return;
    var result = scene.querySelector('[data-om-bundle-result]');
    if (!result) return;
    var nameEl = result.querySelector('[data-om-bundle-name]');
    var listEl = result.querySelector('[data-om-bundle-items]');
    var priceEl = result.querySelector('[data-om-bundle-price]');
    var compareEl = result.querySelector('[data-om-bundle-compare]');
    var priceLabelEl = result.querySelector('[data-om-bundle-price-label]');
    var btn = result.querySelector('[data-om-bundle-add]');
    var row = result.querySelector('.om-creator__bundle-row');
    var mediaEl = result.querySelector('[data-om-bundle-media]');
    var imgEl = result.querySelector('[data-om-bundle-image]');
    var name = pill.getAttribute('data-name') || '';
    var price = pill.getAttribute('data-price') || '';
    var compare = (pill.getAttribute('data-compare') || '').trim();
    var ids = pill.getAttribute('data-ids') || '';
    var imageUrl = (pill.getAttribute('data-image') || '').trim();
    var imageAlt = (pill.getAttribute('data-image-alt') || name).trim();
    var items = (pill.getAttribute('data-items') || '')
      .split('||')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    if (nameEl) nameEl.textContent = name;
    if (priceEl) priceEl.textContent = price;
    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
    if (priceLabelEl) priceLabelEl.textContent = resolvePriceLabel(root, scene, pill);
    if (listEl) {
      listEl.innerHTML = items
        .map(function (item) {
          return '<li>' + item.replace(/</g, '&lt;') + '</li>';
        })
        .join('');
    }
    if (mediaEl && imgEl) {
      if (imageUrl) {
        imgEl.src = imageUrl;
        imgEl.alt = imageAlt;
        mediaEl.hidden = false;
        if (row) row.classList.add('has-media');
      } else {
        imgEl.removeAttribute('src');
        imgEl.alt = '';
        mediaEl.hidden = true;
        if (row) row.classList.remove('has-media');
      }
    }
    if (btn) {
      btn.setAttribute('data-ids', ids);
      btn.disabled = !ids;
    }
    scene.querySelectorAll('[data-om-bundle]').forEach(function (p) {
      p.classList.toggle('is-active', p === pill);
    });
  }

  function initBundles(root) {
    root.querySelectorAll('[data-om-scene]').forEach(function (scene) {
      var pills = scene.querySelectorAll('[data-om-bundle]');
      var first = pills[0];
      if (first) applyBundle(root, scene, first);
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          applyBundle(root, scene, pill);
        });
      });
    });

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-om-bundle-add]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      var ids = (btn.getAttribute('data-ids') || '').split(',');
      var ok = btn.parentElement && btn.parentElement.querySelector('[data-om-ok]');
      addItems(ids, btn)
        .then(function () {
          if (ok) ok.classList.add('is-on');
        })
        .catch(function () {});
    });
  }

  function moneyFromCents(cents, moneyFormat) {
    var n = Number(cents) || 0;
    var raw = (n / 100).toFixed(2);
    if (moneyFormat && moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', raw);
    }
    return '$' + raw;
  }

  function initAccessories(root) {
    var cards = root.querySelectorAll('[data-om-acc]');
    var countEl = root.querySelector('[data-om-acc-count]');
    var totalEl = root.querySelector('[data-om-acc-total]');
    var addBtn = root.querySelector('[data-om-acc-add]');
    var ok = root.querySelector('[data-om-acc-ok]');
    if (!cards.length) return;

    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    function selected() {
      return Array.prototype.filter.call(cards, function (card) {
        return card.classList.contains('is-on');
      });
    }

    function refresh() {
      var list = selected();
      var total = 0;
      list.forEach(function (card) {
        total += Number(card.getAttribute('data-price-cents') || 0);
      });
      if (countEl) countEl.textContent = String(list.length);
      if (totalEl) totalEl.textContent = moneyFromCents(total, moneyFormat);
      if (addBtn) addBtn.disabled = list.length === 0;
      if (ok) ok.classList.remove('is-on');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        event.preventDefault();
        card.classList.toggle('is-on');
        refresh();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var ids = selected()
          .map(function (card) {
            return card.getAttribute('data-variant-id');
          })
          .filter(Boolean);
        addItems(ids, addBtn)
          .then(function () {
            if (ok) ok.classList.add('is-on');
          })
          .catch(function () {});
      });
    }

    refresh();

    var accGrid = root.querySelector('[data-om-acc-grid]');
    var accToggle = root.querySelector('[data-om-acc-toggle]');
    var accToggleWrap = accToggle && accToggle.closest('.om-creator__acc-more');
    var accTabs = root.querySelector('[data-om-acc-tabs]');
    var accTabBtns = accTabs ? accTabs.querySelectorAll('[data-om-acc-tab-btn]') : [];
    var accTabPrev = root.querySelector('[data-om-acc-tabs-prev]');
    var accTabNext = root.querySelector('[data-om-acc-tabs-next]');
    var hasAccTabs = !!(accGrid && accGrid.classList.contains('has-acc-tabs') && accTabBtns.length);

    function isMobileAcc() {
      return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches;
    }

    function visibleAccCards() {
      return Array.prototype.filter.call(cards, function (card) {
        return !card.classList.contains('is-tab-off');
      });
    }

    function applyAccCollapse() {
      if (!accGrid || !accGrid.classList.contains('has-acc-tabs')) return;
      var vis = visibleAccCards();
      var limit = isMobileAcc() ? 2 : 4;
      var collapsed = accGrid.classList.contains('is-collapsed');
      Array.prototype.forEach.call(cards, function (card) {
        card.classList.remove('is-extra');
      });
      vis.forEach(function (card, i) {
        if (collapsed && i >= limit) card.classList.add('is-extra');
      });
      var needToggle = vis.length > limit;
      if (accToggleWrap) accToggleWrap.hidden = !needToggle;
      else if (accToggle) accToggle.hidden = !needToggle;
    }

    function setAccTab(handle) {
      Array.prototype.forEach.call(cards, function (card) {
        var tab = card.getAttribute('data-om-acc-tab') || '';
        var on = tab === '' || tab === handle;
        card.classList.toggle('is-tab-off', !on);
      });
      Array.prototype.forEach.call(accTabBtns, function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-om-acc-tab-btn') === handle);
      });
      if (accGrid && accGrid.classList.contains('is-collapsed') === false) {
        accGrid.classList.add('is-collapsed');
        if (accToggle) {
          accToggle.classList.remove('is-open');
          accToggle.setAttribute('aria-expanded', 'false');
          var lab = accToggle.querySelector('[data-om-acc-toggle-label]');
          if (lab) lab.textContent = accToggle.getAttribute('data-open-text') || 'Show more';
        }
      }
      applyAccCollapse();
    }

    if (accGrid && accToggle) {
      var accToggleLabel = accToggle.querySelector('[data-om-acc-toggle-label]');
      var accOpenText = accToggle.getAttribute('data-open-text') || 'Show more';
      var accCloseText = accToggle.getAttribute('data-close-text') || 'Show less';
      accToggle.addEventListener('click', function () {
        var expand = accGrid.classList.contains('is-collapsed');
        accGrid.classList.toggle('is-collapsed', !expand);
        accToggle.classList.toggle('is-open', expand);
        accToggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
        if (accToggleLabel) accToggleLabel.textContent = expand ? accCloseText : accOpenText;
        applyAccCollapse();
      });
    }

    if (hasAccTabs) {
      Array.prototype.forEach.call(accTabBtns, function (btn) {
        btn.addEventListener('click', function () {
          var handle = btn.getAttribute('data-om-acc-tab-btn') || '';
          setAccTab(handle);
          if (accTabs && isMobileAcc() && typeof btn.scrollIntoView === 'function') {
            btn.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          }
          updateAccTabArrows();
        });
      });
      applyAccCollapse();
      window.addEventListener('resize', applyAccCollapse);
    }

    function accTabsMaxScroll() {
      if (!accTabs) return 0;
      return Math.max(0, accTabs.scrollWidth - accTabs.clientWidth);
    }

    function setAccTabArrowVisible(arrow, visible) {
      if (!arrow) return;
      arrow.classList.toggle('is-visible', !!visible);
      arrow.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function updateAccTabArrows() {
      if (!accTabs || !accTabPrev || !accTabNext) return;
      if (!isMobileAcc()) {
        setAccTabArrowVisible(accTabPrev, false);
        setAccTabArrowVisible(accTabNext, false);
        return;
      }
      var maxScroll = accTabsMaxScroll();
      if (maxScroll <= 2) {
        setAccTabArrowVisible(accTabPrev, false);
        setAccTabArrowVisible(accTabNext, false);
        return;
      }
      var sl = accTabs.scrollLeft;
      setAccTabArrowVisible(accTabPrev, sl > 4);
      setAccTabArrowVisible(accTabNext, sl < maxScroll - 4);
    }

    if (accTabs && accTabPrev && accTabNext) {
      accTabs.addEventListener('scroll', updateAccTabArrows, { passive: true });
      accTabPrev.addEventListener('click', function () {
        accTabs.scrollTo({ left: 0, behavior: 'smooth' });
      });
      accTabNext.addEventListener('click', function () {
        accTabs.scrollTo({ left: accTabsMaxScroll(), behavior: 'smooth' });
      });
      window.addEventListener('resize', updateAccTabArrows);
      updateAccTabArrows();
    }
  }

  function initCalendar(root) {
    var cal = root.querySelector('[data-om-cal]');
    if (!cal) return;
    var grid = cal.querySelector('[data-om-cal-grid]');
    var label = cal.querySelector('[data-om-cal-label]');
    var prev = cal.querySelector('[data-om-cal-prev]');
    var next = cal.querySelector('[data-om-cal-next]');
    if (!grid || !label) return;

    var giftDays = [];
    var giftRanges = [];
    var jsonEl = cal.querySelector('[data-om-gifts]');
    if (jsonEl) {
      try {
        var parsed = JSON.parse(jsonEl.textContent || '{}');
        if (Array.isArray(parsed)) {
          parsed.forEach(function (g) {
            if (g && (g.start || g.end)) giftRanges.push(g);
            else giftDays.push(g);
          });
        } else {
          giftDays = parsed.days || [];
          giftRanges = parsed.ranges || [];
        }
      } catch (e) {
        giftDays = [];
        giftRanges = [];
      }
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function parseYmd(raw) {
      var s = String(raw || '')
        .trim()
        .replace(/[./年]/g, '-')
        .replace(/日/g, '')
        .replace(/\s+/g, '-');
      s = s.replace(/-+/g, '-').replace(/^-|-$/g, '');
      var m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
      if (!m) return null;
      return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    }

    function startOfDay(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    function weekStartOf(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay());
    }

    function weekOverlapsRange(ws, rangeStart, rangeEnd) {
      if (!rangeStart || !rangeEnd) return true;
      var we = new Date(ws.getFullYear(), ws.getMonth(), ws.getDate() + 6);
      return ws.getTime() <= rangeEnd.getTime() && we.getTime() >= rangeStart.getTime();
    }

    function clampWeekStart(ws, rangeStart, rangeEnd) {
      if (!rangeStart || !rangeEnd) return ws;
      var minWs = weekStartOf(rangeStart);
      var maxWs = weekStartOf(rangeEnd);
      if (ws.getTime() < minWs.getTime()) return minWs;
      if (ws.getTime() > maxWs.getTime()) return maxWs;
      return ws;
    }

    var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var today = startOfDay(new Date());
    var rangeStart = parseYmd(cal.getAttribute('data-cal-start'));
    var rangeEnd = parseYmd(cal.getAttribute('data-cal-end'));
    if (rangeStart && rangeEnd && rangeEnd.getTime() < rangeStart.getTime()) {
      var swap = rangeStart;
      rangeStart = rangeEnd;
      rangeEnd = swap;
    }
    var hasRange = Boolean(rangeStart && rangeEnd);

    var weekStart;
    if (hasRange) {
      if (today.getTime() < rangeStart.getTime()) weekStart = weekStartOf(rangeStart);
      else if (today.getTime() > rangeEnd.getTime()) weekStart = weekStartOf(rangeEnd);
      else weekStart = weekStartOf(today);
      weekStart = clampWeekStart(weekStart, rangeStart, rangeEnd);
    } else {
      weekStart = weekStartOf(today);
    }

    function inRange(date) {
      if (!hasRange) return true;
      var t = startOfDay(date).getTime();
      return t >= rangeStart.getTime() && t <= rangeEnd.getTime();
    }

    function giftLabel(date) {
      if (!inRange(date)) return '';
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var t = startOfDay(date).getTime();
      var exact = '';
      var ranged = '';

      giftRanges.forEach(function (g) {
        var text = (g && g.label) || '';
        if (!text) return;
        var gs = parseYmd(g.start);
        var ge = parseYmd(g.end);
        if (!gs || !ge) return;
        if (ge.getTime() < gs.getTime()) {
          var tmp = gs;
          gs = ge;
          ge = tmp;
        }
        if (t >= gs.getTime() && t <= ge.getTime()) ranged = text;
      });

      giftDays.forEach(function (g) {
        var raw = String((g && g.day) || '').trim();
        var text = (g && g.label) || '';
        if (!raw || !text) return;
        var giftDate = parseYmd(raw);
        if (giftDate) {
          if (
            giftDate.getFullYear() === y &&
            giftDate.getMonth() + 1 === m &&
            giftDate.getDate() === d
          ) {
            exact = text;
          }
        } else {
          var num = raw.match(/(\d{1,2})\s*$/);
          if (num && Number(num[1]) === d) exact = text;
        }
      });

      return exact || ranged;
    }

    function syncNav() {
      if (prev) {
        var prevWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() - 7);
        prev.disabled = hasRange && !weekOverlapsRange(prevWs, rangeStart, rangeEnd);
      }
      if (next) {
        var nextWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 7);
        next.disabled = hasRange && !weekOverlapsRange(nextWs, rangeStart, rangeEnd);
      }
    }

    function render() {
      var days = [];
      var i;
      for (i = 0; i < 7; i++) {
        days.push(new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + i));
      }
      var first = days[0];
      var last = days[6];
      if (first.getFullYear() !== last.getFullYear()) {
        label.textContent =
          months[first.getMonth()] +
          ' ' +
          first.getDate() +
          ', ' +
          first.getFullYear() +
          ' — ' +
          months[last.getMonth()] +
          ' ' +
          last.getDate() +
          ', ' +
          last.getFullYear();
      } else {
        label.textContent =
          months[first.getMonth()] +
          ' ' +
          first.getDate() +
          ' — ' +
          months[last.getMonth()] +
          ' ' +
          last.getDate() +
          ', ' +
          first.getFullYear();
      }

      grid.innerHTML = days
        .map(function (date) {
          var outside = !inRange(date);
          var gift = giftLabel(date);
          var cls = 'om-creator__cal-cell';
          if (outside) cls += ' is-out';
          if (gift) cls += ' is-gift';
          if (date.toDateString() === today.toDateString()) cls += ' is-today';
          return (
            '<div class="' +
            cls +
            '">' +
            '<span class="om-creator__cal-wday">' +
            weekNames[date.getDay()] +
            '</span>' +
            '<span class="om-creator__cal-num">' +
            date.getDate() +
            '</span>' +
            (gift ? '<span class="om-creator__cal-gift">' + gift.replace(/</g, '&lt;') + '</span>' : '') +
            '</div>'
          );
        })
        .join('');
      syncNav();
    }

    if (prev) {
      prev.addEventListener('click', function () {
        var nextWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() - 7);
        if (hasRange && !weekOverlapsRange(nextWs, rangeStart, rangeEnd)) return;
        weekStart = nextWs;
        render();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var nextWs = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 7);
        if (hasRange && !weekOverlapsRange(nextWs, rangeStart, rangeEnd)) return;
        weekStart = nextWs;
        render();
      });
    }
    render();
  }

  function initCompare(root) {
    var btn = root.querySelector('[data-om-compare-toggle]');
    var extra = root.querySelector('[data-om-compare-extra]');
    var label = root.querySelector('[data-om-compare-label]');
    if (!btn || !extra) return;
    var openText = btn.getAttribute('data-open-text') || 'Show full comparison';
    var closeText = btn.getAttribute('data-close-text') || 'Hide full comparison';
    btn.addEventListener('click', function () {
      var hidden = extra.hasAttribute('hidden');
      if (hidden) extra.removeAttribute('hidden');
      else extra.setAttribute('hidden', '');
      btn.classList.toggle('is-open', hidden);
      if (label) label.textContent = hidden ? closeText : openText;
    });
  }

  function initSurvey(root) {
    var form = root.querySelector('[data-om-survey]');
    if (!form) return;
    var submit = form.querySelector('[data-om-submit]');
    var success = root.querySelector('[data-om-survey-ok]');
    var scriptUrl = (root.getAttribute('data-script-url') || '').trim();
    var ratingInput = form.querySelector('[name="rating"]');
    var npsInput = form.querySelector('[name="nps"]');
    var stars = form.querySelectorAll('[data-om-star]');
    var npsBtns = form.querySelectorAll('[data-om-nps]');

    function setStars(value) {
      stars.forEach(function (star) {
        star.classList.toggle('is-on', Number(star.getAttribute('data-om-star')) <= value);
      });
    }

    stars.forEach(function (star) {
      star.addEventListener('click', function () {
        var value = Number(star.getAttribute('data-om-star')) || 0;
        if (ratingInput) ratingInput.value = String(value);
        setStars(value);
      });
    });

    npsBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-om-nps');
        if (npsInput) npsInput.value = value;
        npsBtns.forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
      });
    });

    function checkedValues(name) {
      return Array.prototype.map
        .call(form.querySelectorAll('input[name="' + name + '"]:checked'), function (el) {
          return el.value;
        })
        .filter(Boolean);
    }

    function isComplete() {
      var model = form.querySelector('input[name="model"]:checked');
      var rating = ratingInput && Number(ratingInput.value) > 0;
      var pain = checkedValues('painpoint').length > 0;
      var prepurchase = form.querySelector('input[name="prepurchase"]:checked');
      var improve = checkedValues('improve').length > 0;
      var recommend = (form.querySelector('[name="recommend_words"]') || {}).value;
      var nps = npsInput && npsInput.value !== '' && Number(npsInput.value) >= 0;
      var feedback = (form.querySelector('[name="feedback"]') || {}).value;
      var email = (form.querySelector('[name="email"]') || {}).value;
      var emailOk = email && /[^\s@]+@[^\s@]+\.[^\s@]+/.test(email.trim());
      return !!(
        model &&
        rating &&
        pain &&
        prepurchase &&
        improve &&
        String(recommend || '').trim() &&
        nps &&
        String(feedback || '').trim() &&
        emailOk
      );
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!isComplete() || !scriptUrl) return;
      var payload = {
        timestamp: new Date().toISOString(),
        model: (form.querySelector('input[name="model"]:checked') || {}).value || '',
        rating: ratingInput ? ratingInput.value : '',
        painpoints: checkedValues('painpoint').join(', '),
        prepurchase: (form.querySelector('input[name="prepurchase"]:checked') || {}).value || '',
        improve: checkedValues('improve').join(', '),
        recommend_words: (form.querySelector('[name="recommend_words"]') || {}).value || '',
        nps: npsInput ? npsInput.value : '',
        feedback: (form.querySelector('[name="feedback"]') || {}).value || '',
        email: (form.querySelector('[name="email"]') || {}).value || '',
        page_url: window.location.href
      };

      submit.disabled = true;
      var original = submit.textContent;
      submit.textContent = submit.getAttribute('data-submitting') || 'Submitting…';

      fetch(scriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      })
        .catch(function () {})
        .then(function () {
          if (success) success.classList.add('is-on');
          form.reset();
          setStars(0);
          npsBtns.forEach(function (b) {
            b.classList.remove('is-on');
          });
          if (ratingInput) ratingInput.value = '0';
          if (npsInput) npsInput.value = '';
          submit.textContent = original;
          submit.disabled = false;
        });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-om-creator]').forEach(initRoot);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.querySelector('[data-om-creator]');
    if (!root) return;
    relocateAnchorNav(root);
    var loaded = event.target && event.target.querySelector('[data-om-creator]');
    if (loaded) {
      delete loaded.dataset.omReady;
      initRoot(loaded);
    }
  });
})();
